import React, { PureComponent } from 'react'
import { Layout, Form, PageHeader, Icon, Table, Button, Modal, Input, Select, message } from 'antd'
import {orderDetail, vendorsList, sendOrder, remarkOrder} from '_src/api/api'
import PrevImg from '_src/components/PrevImg/PrevImg'
import {getStatus} from './commo/common'
import './order.less'

const {TextArea} = Input
const {Option} = Select

@Form.create({name: ''})
class OrderDetail extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: true,
      userAddress: [],
      orderInfo: [],
      sendSaving: false,
      remarkSaving: false,
    }
  }
  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    this.loadOrderDetail(id)
  }
  
  loadOrderDetail = (id) => {
    orderDetail({id})
      .then(res => {
        const data = res.data
        this.setState({
          isLoading: false,
          ...data,
          // 收货地址
          userAddress: [{
            address: data.address,
            mobile: data.mobile,
            consignee: data.consignee,
          }],
          // 订单信息
          orderInfo: [{
            orderSn: data.orderSn,
            logisticCode: data.logisticCode,
            mobile: data.mobile,
            orderSource: data.orderSource,
            createAt: data.createAt,
            confirmAt: data.confirmAt,
            merchantMessage: data.merchantMessage,
          }],
          // 费用信息
          moneyInfo: [{
  
          }],
          infoList: [{
            ...data
          }],
        })
      })
      .catch(err => {
        this.setState({
          isLoading: false,
        })
      })
  }

  // 订单发货显示弹窗
  deliverOrder = () => {
    vendorsList().then(res => {
      this.setState({
        sendVisible: true,
        sendList: res.data
      })
    })
  }

  // 发货弹窗内容
  genSend () {
    const { getFieldDecorator } = this.props.form
    const {sendList} = this.state
    return (
      <Form onSubmit={this.sendSubmit} style={{paddingLeft: 60, paddingTop: 20}}>
        <Form.Item label="物流公司：" className='flex'>
          {getFieldDecorator('shipperCode', {
            rules: [{
              required: true,
              message: '请选择物流公司',
            }],
          })(
            <Select
              style={{width: 250}}
              onChange={this.handleSelectChange}
              placeholder='请选择物流公司'
            >
              {sendList.map(item => <Option value={item.code} key={item.code}>{item.name}</Option>)}
            </Select>
          )}
        </Form.Item>
        <Form.Item label="物流单号：" className='flex'>
          {getFieldDecorator('logisticCode', {
            rules: [{
              required: true,
              message: '请输入物流单号',
            }],
          })(
            <Input placeholder="请输入物流单号" style={{ width: 250, height: 40 }} />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={this.state.sendSaving} disabled={this.state.sendSaving} size='large' style={{ width: 250, marginLeft: 81, marginTop: 10 }}>保存</Button>
        </Form.Item>
      </Form>
    )
  }

  // 订单发货
  sendSubmit = e => {
    const {orderSn, id, sendSaving} = this.state
    const _this = this
    e.preventDefault()
    if (sendSaving) return
    this.props.form.validateFields((err, values) => {
      if (!err) {
        _this.setState({ sendSaving: true })
        sendOrder({
          orderSn,
          shipperCode: values.shipperCode,
          logisticCode: values.logisticCode,
        })
          .then(res => {
            _this.setState({sendVisible: false, sendSaving: false})
            _this.loadOrderDetail(id)
            message.success('订单发货成功！', 2)
          })
          .catch(() => {
            _this.setState({ sendSaving: false })
          })
      }
    })
  }

  // 获取备注元素
  genRemark () {
    const {merchantMessage} = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <Form onSubmit={this.remarkSubmit} style={{paddingLeft: 60, paddingTop: 20}}>
        <Form.Item className='flex'>
          {getFieldDecorator('merchantMessage', {
            rules: [{
              required: true,
              message: '请输入订单备注信息',
            }],
            initialValue: merchantMessage || ''
          })(
            <TextArea placeholder="请输入订单备注信息" rows={4} style={{ width: 340 }} />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={this.state.remarkSaving} disabled={this.state.remarkSaving} size='large' style={{ width: 340, marginTop: 10 }}>保存</Button>
        </Form.Item>
      </Form>
    )
  }

  // 订单备注
  remarkSubmit = e => {
    const {id, remarkSaving} = this.state
    const _this = this
    e.preventDefault()
    if (remarkSaving) return
    this.props.form.validateFields((err, values) => {
      if (!err) {
        _this.setState({ remarkSaving: true })
        remarkOrder({
          id,
          remark: values.merchantMessage,
        })
          .then(res => {
            _this.setState({remarkVisible: false, remarkSaving: false})
            _this.loadOrderDetail(id)
            message.success('订单备注成功！', 2)
          })
          .catch(() => {
            _this.setState({ remarkSaving: false })
          })
      }
    })
  }

  render () {
    const {userAddress, orderInfo, infoList, orderGoods, status, sendVisible, remarkVisible} = this.state
    return (
      <Layout className='order-detail-page'>
        <PrevImg ref={el => this.PrevImg = el} />
        <PageHeader className='order-detail-title flex-h-a' title={'订单详情 - ' + getStatus(status)} style={{borderLeft: '5px solid #1890ff'}} />
        { status === 51 || status === 62
          ? <div className='refund-inner'>当前订单状态：{status === 51 ? '申请退款' : '退款完成'}</div>
          : (
            <ul className='detail-header flex-j-a'>
              <li className={'item ' + (status !== 12 && status !== 13 ? 'select' : '')}>
                <div className="icon-inner"><Icon type="shopping" theme="filled" className='icon' /></div>
                <p className='item-title'>提交订单</p>
                {/* <span className='item-time'>15点10分</span> */}
              </li>
              <li className={'item ' + (status >= 21 ? 'select' : '')}>
                <div className="icon-inner"><Icon type="account-book" theme="filled" className='icon' /></div>
                <p className='item-title'>支付订单</p>
              </li>
              <li className={'item ' + (status >= 31 ? 'select' : '')}>
                <div className="icon-inner"><Icon type="medicine-box" theme="filled" className='icon' /></div>
                <p className='item-title'>商家发货</p>
              </li>
              <li className={'item ' + (status === 41 ? 'select' : '')}>
                <div className="icon-inner"><Icon type="check-circle" theme="filled" className='icon' /></div>
                <p className='item-title'>确认收货-完成订单</p>
              </li>
            </ul>
          )
        }

        <div className="tool-inner flex-h-a">
          {status === 21 && <Button type='primary' icon='tag' style={{marginRight: 15}} onClick={this.deliverOrder}>发货</Button>}
          {/* {(status === 11 || status === 21) && <Button icon='close-circle' type="danger" ghost style={{marginRight: 15}}>取消订单</Button>} */}
          <Button icon='pushpin' onClick={() => this.setState({remarkVisible: true})}>备注</Button> 
        </div>

        <div className='order-detail-inner'>
          <div className="info-item">
            <PageHeader title={<span><Icon type="profile" /> 基本信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '订单编号',
                    dataIndex: 'orderSn',
                    key: 'orderSn',
                  },
                  {
                    title: '下单时间',
                    dataIndex: 'createAt',
                  },
                  {
                    title: '用户账号',
                    dataIndex: 'mobile',
                  },
                  {
                    title: '支付方式',
                    render: item => '暂时空缺'
                  },
                  {
                    title: '订单来源',
                    dataIndex: 'orderSource',
                    render: item => item === 1 ? 'APP' : 'H5'
                  },
                  {
                    title: '物流单号',
                    dataIndex: 'logisticCode',
                    render: item => item || '无'
                  },
                  {
                    title: '自动确认收货时间',
                    dataIndex: 'confirmAt',
                    render: item => item || '--'
                  },
                  {
                    title: '订单备注',
                    dataIndex: 'merchantMessage',
                  },
                ]
              }
              dataSource={orderInfo}
              bordered
              rowKey="orderSn"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="user" /> 收货人信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '收货人',
                    dataIndex: 'consignee',
                    key: 'consignee',
                  },
                  {
                    title: '手机号码',
                    dataIndex: 'mobile',
                  },
                  {
                    title: '收货地址',
                    dataIndex: 'address',
                  },
                ]
              }
              dataSource={userAddress}
              bordered
              rowKey="consignee"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="file-search" /> 商品信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '商品图片',
                    key: 'id',
                    width: 150,
                    render: item => <img src={item.picUrl} style={{width: 120, height: 120, cursor: 'pointer'}} alt='' onClick={() => this.PrevImg.show(item.picUrl)} />
                  },
                  {
                    title: '商品名称',
                    render: item => item.goods.goodsName
                  },
                  {
                    title: '价格',
                    render: item => (item.price / 100).toFixed(2)
                  },
                  {
                    title: '规格',
                    render: item => item.goodsSpecification.specificationsName
                  },
                  {
                    title: '数量',
                    render: item => item.number
                  },
                  {
                    title: '小计',
                    render: item => (item.price / 100 * item.number).toFixed(2)
                  },
                ]
              }
              dataSource={orderGoods}
              bordered
              rowKey="id"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="account-book" /> 费用信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '商品费用（￥）',
                    dataIndex: 'goodsPrice',
                    render: item => item / 100
                  },
                  {
                    title: '运费（￥）',
                    dataIndex: 'freightPrice',
                    render: item => item / 100
                  },
                  {
                    title: '优惠券（￥）',
                    dataIndex: 'couponPrice',
                    render: item => item / 100
                  },
                  {
                    title: '订单总金额（￥）',
                    dataIndex: 'orderPrice',
                    render: item => item / 100
                  },
                  {
                    title: '应付款金额（￥）',
                    dataIndex: 'realPrice',
                    render: item => <span style={{fontSize: 18, fontWeight: 'bold', color: '#1890ff'}} >{item / 100}</span>
                  },
                ]
              }
              dataSource={infoList}
              bordered
              rowKey="id"
              pagination={false}
            />
          </div>
        </div>

        <Modal
          title="订单发货"
          visible={sendVisible}
          destroyOnClose
          onCancel={()=>this.setState({sendVisible: false})}
          footer={false}
        >
          {sendVisible && this.genSend()}
        </Modal>

        <Modal
          title="订单备注"
          visible={remarkVisible}
          destroyOnClose
          onCancel={()=>this.setState({remarkVisible: false})}
          footer={false}
        >
          {remarkVisible && this.genRemark()}
        </Modal>

      </Layout>
    )
  }
}

export default OrderDetail